import isObjectLike from './isObjectLike';
import isPlainObject from './isPlainObject';

/**
 * Checks if `value` is likely a DOM element.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a DOM element,
 *  else `false`.
 * @example
 *
 * _.isElement(document.body);
 * // => true
 *
 * _.isElement('<body>');
 * // => false
 */
function isElement(value) {
  return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
}

export default isElement;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/isElement.js
// module id = 258
// module chunks = 0